var _path, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 40 48",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.4 0 8.4 14.553h-16.8z",
    fill: "#ffab00",
    transform: "matrix(-1 0 0 -1 28.792 48)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#ffab00",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.786 696.129v.554a1.289 1.289 0 0 0 1.289 1.289 1.289 1.289 0 0 0 1.289-1.289v-.554",
    strokeWidth: 1.417,
    transform: "translate(-477.677 -674.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 14.331,
    rx: 2.872,
    strokeWidth: 1.5,
    width: 22.002,
    x: 9.397,
    y: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.53 0h2.387a3.53 3.53 0 0 1 3.53 3.53h-9.447a3.53 3.53 0 0 1 3.53-3.53z",
    strokeWidth: 1.5,
    transform: "translate(15.674 11.069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.074 690.345a31.91 31.91 0 0 0 22 0",
    strokeWidth: 1.5,
    transform: "translate(-458.677 -671.023)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.052e2b07eaa8bcfc9814ed48960bf8b3.svg";
export { ForwardRef as ReactComponent };